import { render, staticRenderFns } from "./ProjectValuationExternalReportPage19.vue?vue&type=template&id=8936dd4c&scoped=true&"
import script from "./ProjectValuationExternalReportPage19.vue?vue&type=script&lang=ts&"
export * from "./ProjectValuationExternalReportPage19.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectValuationExternalReportPage19.vue?vue&type=style&index=0&id=8936dd4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8936dd4c",
  null
  
)

export default component.exports